import { useState } from "react";
import { bpsToPercent, projectConfig } from "../config/project";

const questions = [
  {
    question: "What is GameCoin?",
    answer:
      "GameCoin is an independent community token on Robinhood Chain. Its cultural lineage begins with the 2021 GameStop saga and GameStop's historical Game Coin promotion, then carries that player-driven market energy into an onchain GAMECOIN/GME market and holder-reward loop.",
  },
  {
    question: "Is this an official GameStop token?",
    answer:
      "No. GameCoin is not created, sponsored, endorsed, or operated by GameStop. The 2021 GameStop post is historical inspiration only. GameStop's original Game Coin was a retail rewards promotion, not this crypto token.",
  },
  {
    question: "What is tokenized GME?",
    answer:
      "Tokenized GME is an onchain tokenized-stock product. It is not the same as owning directly registered GameStop shares, and availability may depend on jurisdiction and provider restrictions.",
  },
  {
    question: "How do GME rewards work?",
    answer:
      "Flap's standard V6 tax-token system collects the configured tax in GME. Because GME is both the quote token and dividend token, the holder allocation can enter the standard dividend distributor directly without a reward-token swap or custom vault.",
  },
  {
    question: "Is staking required?",
    answer:
      "No staking is required. Holder rewards use Flap's standard onchain dividend distributor, subject to the deployed contract behavior.",
  },
  {
    question: "What are the buy and sell taxes?",
    answer: `The configured buy tax is ${bpsToPercent(
      projectConfig.economics.buyTaxBps,
    )}, and the configured sell tax is ${bpsToPercent(
      projectConfig.economics.sellTaxBps,
    )}. Verify the deployed contract before trading.`,
  },
  {
    question: "Where does the trading tax go?",
    answer:
      "The fee allocation is 100% GME holder rewards, with 0% marketing or treasury, 0% burns, 0% additional liquidity, and 0% creator commission. GME is both the quote token and dividend token.",
  },
  {
    question: "How frequently are rewards paid?",
    answer:
      "Flap can process dividends automatically in batches, while manual claiming can also be supported. Timing depends on trading activity, thresholds, gas conditions, and contract processing; no exact payout schedule is promised.",
  },
  {
    question: "Where can GAMECOIN be traded?",
    answer:
      "GAMECOIN trades on Flap against tokenized GME. Always enter through an official link and verify the GAMECOIN contract address before trading.",
  },
  {
    question: "What are the risks?",
    answer:
      "GAMECOIN is experimental. Crypto and tokenized assets can be highly volatile, illiquid, restricted, or lose all value. Smart-contract, market, provider, and regulatory risks apply. Rewards are variable and never guaranteed.",
  },
];

export function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="section-block" id="faq">
      <div className="section-heading">
        <div>
          <span className="section-index">08 / HELP MENU</span>
          <h2>Player guide</h2>
        </div>
        <p>Straight answers about the origin, live market, reward system, and risks.</p>
      </div>
      <div className="faq-list">
        {questions.map((item, index) => {
          const expanded = open === index;
          return (
            <article className={expanded ? "faq-item is-open" : "faq-item"} key={item.question}>
              <h3>
                <button
                  type="button"
                  aria-expanded={expanded}
                  onClick={() => setOpen(expanded ? -1 : index)}
                >
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {item.question}
                  <i aria-hidden="true">{expanded ? "-" : "+"}</i>
                </button>
              </h3>
              <div className="faq-answer" hidden={!expanded}>
                <p>{item.answer}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
